import {GetFileTypes} from "../../helpers/CoreHelpers";

const initialState = {
    items: [],
    fileTypes: [],
    itemsInsertInEditor: [],
    refresh: false,
    submitting: false,
    filesForUpload: 0,
    filesUploadComplete: 0,
    filesUploadFailed: 0,
    showMediaUploadModal: false,
    showMediaSelectModal: false,
    editItemId: null,
    deleteItemId: null,
    item: null,
    selectedWorkspace: "-1",
    selectedMediaType: "-1",
    searchKeyword: "",
    name: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'MEDIA_SET_TYPE':
            return {
                ...state,
                selectedMediaType: action.payload
            };
            
        case 'MEDIA_SET_WORKSPACE':
            return {
                ...state,
                selectedWorkspace: action.payload
            };
            
        case 'MEDIA_SET_SEARCH_KEYWORD':
            return {
                ...state,
                searchKeyword: action.payload
            };
            
        case 'MEDIA_SET_ITEM_FOR_EDIT':
            return {
                ...state,
                editItemId: action.payload,
                deleteItemId: null
            };
            
        case 'MEDIA_SET_ITEM_FOR_DELETION':
            return {
                ...state,
                deleteItemId: action.payload,
                editItemId: null
            };
            
        case 'MEDIA_INSERT_IN_EDITOR_RESET':
            return {
                ...state,
                itemsInsertInEditor: []
            };
            
        case 'MEDIA_INSERT_IN_EDITOR':
            return {
                ...state,
                itemsInsertInEditor: action.payload
            };
            
        case 'MEDIA_SHOW_SELECT_MODAL':
            return {
                ...state,
                name: action.payload.name,
                showMediaSelectModal: true
            };
            
        case 'MEDIA_CLOSE_SELECT_MODAL':
            return {
                ...state,
                showMediaSelectModal: false,
                name: null,
                itemsInsertInEditor: []
            };
            
        case 'MEDIA_SHOW_MEDIA_UPLOAD':
            return {
                ...state,
                showMediaUploadModal: true
            };
            
        case 'MEDIA_CLOSE_MEDIA_UPLOAD':
            return {
                ...state,
                showMediaUploadModal: false
            };
            
        case 'MEDIA_DESTROY_SUCCESS':
            return {
                ...state,
                refresh: true,
                deleteItemId: null
            };
            
        case 'MEDIA_SINGLE_SUCCESS':
            return {
                ...state,
                refresh: false,
                item: action.payload
            };
            
        case 'MEDIA_PUT_SUCCESS':
            return {
                ...state,
                submitting: false,
                refresh: true,
                editItemId: null
            };
            
        case 'MEDIA_UPLOAD_START':
            return {
                ...state,
                submitting: true,
                refresh: false,
                filesForUpload: action.payload,
                filesUploadComplete: 1,
                filesUploadFailed: 0
            };
            
        case 'MEDIA_FILE_UPLOAD_FAILED':
            return {
                ...state,
                filesUploadFailed: state.filesUploadFailed + 1,
            };
            
        case 'MEDIA_FILE_UPLOAD_FINISH':
            return {
                ...state,
                filesUploadComplete: state.filesUploadComplete + 1,
            };
            
        case 'MEDIA_UPLOAD_FINISH':
            return {
                ...state,
                submitting: false,
                refresh: true,
                showMediaUploadModal: false,
                filesForUpload: null,
                filesUploadComplete: 0

            };
            
        case 'MEDIA_GET_SUCCESS':

            return {
                ...state,
                items: action.payload.data,
                fileTypes: GetFileTypes(action.payload.data),
                submitting: false,
                refresh: false
            };
            
        case 'MEDIA_REFRESH_TRUE':
            return {
                ...state,
                refresh: true
            };
            
        case 'MEDIA_REFRESH_FALSE':
            return {
                ...state,
                refresh: false
            };
            
        case 'MEDIA':
            return initialState;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/store/reducers/media.js